import React, { useState } from 'react';
import { Search, MapPin, Briefcase } from 'lucide-react';
import { Button } from './ui/button';
import { Input } from './ui/input';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from './ui/select';
import { experienceLevels } from '../mockData';

const SearchBar = ({ onSearch }) => {
  const [keyword, setKeyword] = useState('');
  const [location, setLocation] = useState('');
  const [experience, setExperience] = useState('');

  const handleSearch = () => {
    onSearch({ keyword, location, experience });
  };

  return (
    <div className="bg-white rounded-lg shadow-lg p-6 max-w-5xl mx-auto">
      <div className="grid grid-cols-1 md:grid-cols-12 gap-4">
        {/* Keyword Search */}
        <div className="md:col-span-4">
          <div className="relative">
            <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 w-5 h-5" />
            <Input
              type="text"
              placeholder="Skills, Designations, Companies"
              value={keyword}
              onChange={(e) => setKeyword(e.target.value)}
              className="pl-10 h-12 border-gray-300 focus:border-[#4a90e2] focus:ring-[#4a90e2]"
            />
          </div>
        </div>

        {/* Experience */}
        <div className="md:col-span-3">
          <Select value={experience} onValueChange={setExperience}>
            <SelectTrigger className="h-12 border-gray-300 focus:border-[#4a90e2] focus:ring-[#4a90e2]">
              <Briefcase className="w-4 h-4 mr-2 text-gray-400" />
              <SelectValue placeholder="Experience" />
            </SelectTrigger>
            <SelectContent>
              {experienceLevels.map((level, index) => (
                <SelectItem key={index} value={level}>
                  {level}
                </SelectItem>
              ))}
            </SelectContent>
          </Select>
        </div>

        {/* Location */}
        <div className="md:col-span-3">
          <div className="relative">
            <MapPin className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 w-5 h-5" />
            <Input
              type="text"
              placeholder="Enter Location"
              value={location}
              onChange={(e) => setLocation(e.target.value)}
              className="pl-10 h-12 border-gray-300 focus:border-[#4a90e2] focus:ring-[#4a90e2]"
            />
          </div>
        </div>

        {/* Search Button */}
        <div className="md:col-span-2">
          <Button
            onClick={handleSearch}
            className="w-full h-12 bg-[#4a90e2] hover:bg-[#3a7bc8] text-white font-semibold transition-colors"
          >
            Search
          </Button>
        </div>
      </div>

      {/* Quick Links */}
      <div className="mt-4 flex flex-wrap gap-2">
        <span className="text-sm text-gray-600">Popular Searches:</span>
        {['Remote Jobs', 'Work From Home', 'Part Time', 'Internship', 'Fresher Jobs'].map((tag, index) => (
          <button
            key={index}
            className="text-sm text-[#4a90e2] hover:underline"
            onClick={() => setKeyword(tag)}
          >
            {tag}
          </button>
        ))}
      </div>
    </div>
  );
};

export default SearchBar;